import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import InstructorDashbordCard from "../../../components/InstructorDashbordCard/InstructorDashbordCard";
import AllCoursesForInstructor from "../../../components/AllCoursesForInstructor/AllCoursesForInstructor";
import OverallPerformanceCard from "../../../components/OverallPerformanceCard/OverallPerformanceCard";
import AllStudentForInstructor from "../../../components/AllStudentForInstructor/AllStudentForInstructor";
import {
  adminGetAllStudentsAPI,
  adminGetAllCoursesAPI,
  resetError,
  getAllInstructorsAPI,
} from "../../../redux/features/adminSlice";
import AdminNotification from "../../../components/Notification/AdminNotification";
import RevenueDetailsGraph from "../../../components/revenueDetailsGraph/revenueDetailsGraph";

export default function AdminDashboard() {
  const dispatch = useDispatch();
  const { students, courses, metrics } = useSelector((state) => state.admin);
  const auth = useSelector((state) => state.auth);
  const adminName = auth?.full_name || "Admin";
  const {
    courses: { loading: coursesLoading },
    students: { loading: studentsLoading },
    instructors: { loading: instructorsLoading },
  } = useSelector((state) => state.admin);

  const [allStudent, setAllStudent] = useState([]);
  const [allCourses, setAllCourses] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch students
        const allStudents = await dispatch(
          getAllInstructorsAPI({ token: auth.token })
        ).unwrap();
        setAllStudent(allStudents);

        const allInstructors = await dispatch(
          adminGetAllStudentsAPI({ token: auth.token })
        ).unwrap();
        // Fetch courses
        const allCourses = await dispatch(
          adminGetAllCoursesAPI({ token: auth.token })
        ).unwrap();
        setAllCourses(allCourses);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    // Call the async function
    if (auth?.token) {
      fetchData();
    } else {
      console.warn("No auth token available");
      dispatch(resetError());
    }

    return () => {};
  }, [auth?.token, dispatch]);

  return (
    <>
      {(coursesLoading || studentsLoading || instructorsLoading) && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3 className="ad-heading-04 fw-bold mb-8">
              Hello {adminName} <span className="ad-heading-02">👋</span>
            </h3>
            <p className="text-gray-01 text-base fw-semibold mb-0">
              Let’s learn something new today!
            </p>
          </div>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>

      {(students.error || courses.error) && (
        <div className="alert alert-danger">
          {students.error || courses.error}
        </div>
      )}
      <div className="row dashboard-card-holder">
        <InstructorDashbordCard
          title={"Active Students"}
          result={metrics.activeStudents.toString()}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"} // Static for now
          dataCard="purple"
          graphLineColor={"#353297"}
        />
        <InstructorDashbordCard
          title={"New Enrollment"}
          result={metrics.newEnrollments.toString()}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"} // Static for now
          dataCard="primary"
          graphLineColor={"#F05203"}
        />
        <InstructorDashbordCard
          title={"All Instructors"}
          result={allStudent?.data?.totalCount}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"} // Static for now
          dataCard="green"
          graphLineColor={"#82BD00"}
        />
        <InstructorDashbordCard
          title={"All Course"}
          result={courses.totalCount.toString()}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"} // Static for now
          dataCard="yellow"
          graphLineColor={"#F0C20C"}
        />
      </div>
      <div className="row">
        <div className="col-12 col-xl-8 mb-24 mb-lg-32">
          <div className="row">
            <div className="col-12 col-md-8 mb-24 mb-lg-32">
              <h3 className="ah-heading-05 fw-bold mb-20">Revenue Details</h3>
              <div className="card-default-style">
                <div className="graph-labels d-flex mb-15 mb-sm-25 mb-md-35 mb-lg-42">
                  <div className="d-flex me-20">
                    <div className="label-box label-theme me-10"></div>
                    <span className="text-black ah-text-sm fw-semibold">
                      Monthly
                    </span>
                  </div>
                  <div className="d-flex me-20">
                    <div className="label-box label-green me-10"></div>
                    <span className="text-black ah-text-sm fw-semibold">
                      Weekly
                    </span>
                  </div>
                  <div className="d-flex me-20">
                    <div className="label-box label-gray me-10"></div>
                    <span className="text-black ah-text-sm fw-semibold">
                      Daily
                    </span>
                  </div>
                </div>
                <RevenueDetailsGraph />
              </div>
            </div>
            <div className="col-12 col-md-4 d-flex flex-column mb-24 mb-lg-32">
              <h3 className="ah-heading-05 fw-bold mb-20">
                Overall Performance
              </h3>
              <OverallPerformanceCard result={metrics.activeStudents.toString()}/>
            </div>
            <div className="col-12 co-xl-4 mb-24 mb-lg-32">
              <div>
                <h3 className="ah-heading-05 fw-bold mb-20">All Courses</h3>
                <AllCoursesForInstructor courses={allCourses?.data} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-4 mb-24 mb-lg-32">
          <h3 className="ah-heading-05 fw-bold mb-20">Instructors</h3>
          <AllStudentForInstructor
            detailNavigate={"/instructor-details"}
            students={allStudent?.data?.details}
          />
        </div>
      </div>
    </>
  );
}
